import { gql } from '@apollo/client';

const SETTING_FIELDS = gql`
  fragment AiClipperSettingFields on AiClipperSetting {
    id
    isEnabled
    config {
      autoApprovalHours
      minDurationMs
      numClips
      burnSubtitles
      mode
    }
  }
`;

export const GET_AI_CLIPPER_SETTINGS = gql`
  query AiClipperSettings {
    aiClipperSettings {
      ...AiClipperSettingFields
    }
  }
  ${SETTING_FIELDS}
`;

export const SET_AI_CLIPPER_SETTINGS = gql`
  mutation SetAiClipperSettings($input: SetAiClipperSettingsInput!) {
    setAiClipperSettings(input: $input) {
      ...AiClipperSettingFields
    }
  }
  ${SETTING_FIELDS}
`;

const ACCESS_FIELDS = gql`
  fragment AiClipperUserAccessFields on AiClipperUserAccess {
    id
    userId
    isEnabled
    isActive
    validUntil
    enabledById
    disabledAt
    note
    channelLogoKey
    channelLogoUrl
    createdAt
    updatedAt
    user {
      id
      slug
      firstName
      lastName
      avatarUrl
    }
  }
`;

export const GET_AI_CLIPPER_USER_ACCESS = gql`
  query AiClipperUserAccess($userId: String!) {
    aiClipperUserAccess(userId: $userId) {
      ...AiClipperUserAccessFields
    }
  }
  ${ACCESS_FIELDS}
`;

export const GET_AI_CLIPPER_USER_ACCESS_LIST = gql`
  query AiClipperUserAccessList($input: AiClipperUserAccessListInput!) {
    aiClipperUserAccessList(input: $input) {
      entities {
        ...AiClipperUserAccessFields
      }
      total
      offset
      limit
    }
  }
  ${ACCESS_FIELDS}
`;

export const SET_AI_CLIPPER_USER_ACCESS = gql`
  mutation SetAiClipperUserAccess($input: SetAiClipperUserAccessInput!) {
    setAiClipperUserAccess(input: $input) {
      ...AiClipperUserAccessFields
    }
  }
  ${ACCESS_FIELDS}
`;

const POST_CANDIDATE_FIELDS = gql`
  fragment PostAiClipCandidateFields on PostAiClipCandidate {
    id
    clipFileName
    clipUrl
    thumbnailUrl
    title
    topic
    description
    score
    transcriptExcerpt
    postCandidateStatus
    imageStatus
    sourceMediaPostVideoId
    createdAt
    sourceMediaPost {
      id
      slug
      title
      store {
        id
        slug
        firstName
        lastName
      }
    }
    mediaPost {
      id
      slug
    }
  }
`;

export const GET_POST_AI_CLIP_CANDIDATES = gql`
  query GetPostAiClipCandidates($input: GetPostAiClipCandidatesInput!) {
    getPostAiClipCandidates(input: $input) {
      entities {
        ...PostAiClipCandidateFields
      }
      total
      offset
      limit
    }
  }
  ${POST_CANDIDATE_FIELDS}
`;

export const ACCEPT_POST_AI_CLIP_CANDIDATE = gql`
  mutation AcceptPostAiClipCandidate($input: AcceptAiClipCandidateInput!) {
    acceptPostAiClipCandidate(input: $input) {
      ...PostAiClipCandidateFields
    }
  }
  ${POST_CANDIDATE_FIELDS}
`;

export const CREATE_PRESIGNED_AI_CLIPPER_CHANNEL_LOGO_URL = gql`
  mutation CreatePresignedAiClipperChannelLogoUrl(
    $input: CreatePresignedAiClipperChannelLogoUrlInput!
  ) {
    createPresignedAiClipperChannelLogoUrl(input: $input) {
      key
      url
      fields
    }
  }
`;

export const REJECT_POST_AI_CLIP_CANDIDATE = gql`
  mutation RejectPostAiClipCandidate($input: RejectAiClipCandidateInput!) {
    rejectPostAiClipCandidate(input: $input) {
      ...PostAiClipCandidateFields
    }
  }
  ${POST_CANDIDATE_FIELDS}
`;
